import spaceStyle, { type SpacingProps } from '@/styles/space'
import { Block } from '@/components/base/Block'
import { Row } from '@/components/base/Layout'
import { Text4 } from '@/components/base/Text'
import { useApp } from '@/hooks/useApp'
import { type Labelsv1Label, type V1AppColorTheme } from 'mnvm-mypage-app-ts-if'
import styled from 'styled-components'

export interface CardLabelProps {
  text: string
  bg: V1AppColorTheme
}

const Container = styled.div<{ bg: V1AppColorTheme }>`
  height: 20px;
  background: ${(props) => props.bg.color};
  border-radius: 4px;
  // align-items: center;
  display: flex;
  padding: 0px 4px;
  gap: 4;
`

const Label = (props: CardLabelProps): JSX.Element => {
  const app = useApp()
  return (
    <Container bg={props.bg}>
      <Text4
        textColor={
          props.bg === app.theme.yellowColor
            ? app.theme.mainTextColor
            : app.theme.whiteTextColor
        }
        margin={{ all: spaceStyle.NONE }}
      >
        {props.text}
      </Text4>
    </Container>
  )
}

export interface Props {
  items: Labelsv1Label[]
  padding?: SpacingProps
}

const Labels = ({ items, padding }: Props): JSX.Element => {
  const app = useApp()
  return (
    <Block padding={padding ?? { vertical: spaceStyle.XS }}>
      <Row gutter={8}>
        {items?.map((e, index) => (
          <Label
            key={index}
            text={e.text ?? ''}
            bg={app.theme.fromAppThemeType(e.appThemeType)}
          />
        ))}
      </Row>
    </Block>
  )
}

export default Labels
